<template>
  <div class="brand-limit-item">
    <b-card no-body class="mx-6">
      <b-card-body class="p-6">
        <b-form>
          <b-row>
            <b-col>
              <b-row>
                <b-col>
                  <b-form-group
                    id="fieldsetBrandLimitText"
                    :label-cols="3"
                    breakpoint="md"
                    label="Brand Limit Title*:"
                    label-for="inputBrandLimitText"
                  >
                    <b-form-input
                      debounce="500"
                      name="inputBrandLimitText"
                      v-model="brandLimitText"
                      v-validate="'required'"
                      data-vv-as="Brand Limit Title"
                      :class="{'input': true, 'text-danger': errors.has('inputBrandLimitText') }"
                      placeholder="Brand Limit Text"
                      :disabled="isReadonly"
                    ></b-form-input>
                    <span class="text-danger">{{ errors.first('inputBrandLimitText') }}</span>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-form-group
                    id="fieldsetUnlimitedFlag"
                    :label-cols="3"
                    breakpoint="md"
                    label="Unlimited:"
                    label-for="inputUnlimitedFlag"
                  >
                    <b-form-checkbox
                      debounce="500"
                      v-model="unlimitedFlag"
                      name="checkboxUnlimitedFlag"
                      data-vv-as="Unlimited"
                      :class="{'input': true, 'text-danger': errors.has('checkboxUnlimitedFlag') }"
                      :disabled="isReadonly"
                    ></b-form-checkbox>
                    <span class="text-danger">{{ errors.first('checkboxUnlimitedFlag') }}</span>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-form-group
                    id="fieldsetUpperLimit"
                    :label-cols="3"
                    breakpoint="md"
                    label="Upper Limit*:"
                    label-for="inputUpperLimit"
                  >
                    <b-form-input
                      debounce="500"
                      v-model="upperLimit"
                      name="inputUpperLimit"
                      v-validate="'required'"
                      data-vv-as="Upper Limit"
                      :class="{'input': true, 'text-danger': errors.has('inputUpperLimit') }"
                      placeholder="Upper Limit"
                      :disabled="isUpperLimitDisabled"
                    ></b-form-input>
                    <span class="text-danger">{{ errors.first('inputUpperLimit') }}</span>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-form-group
                    id="fieldsetBrandCount"
                    :label-cols="3"
                    breakpoint="md"
                    label="Current Count:"
                    label-for="inputBrandCount"
                  >
                    <b-form-input
                      v-model="brandCount"
                      name="inputBrandCount"
                      data-vv-as="Brand Count"
                      :disabled="true"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>
            <b-col>
              <b-form-group
                id="fieldsetOffers"
                :label-cols="2"
                breakpoint="md"
                label="Offers*:"
                label-for="listOffers">
                <b-row v-if="brandLimit && brandLimit.copay_offers">
                  <b-col>
                    <VBrandLimitOfferList
                      :brandLimitOffers="brandLimit.copay_offers"
                      :isReadonly="isReadonly"
                      @remove="removeOffer">
                    </VBrandLimitOfferList>
                  </b-col>
                  <b-col class="offer-add" cols="1" row v-if="!isReadonly">
                    <a @click="editOffers">
                      <i class="fa fa-plus-circle"></i>
                    </a>
                  </b-col>
                </b-row>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="1" sm="2" offset="10" offset-sm="8">
              <b-button variant="secondary" block @click="clear()">Cancel</b-button>
            </b-col>
            <b-col cols="1" sm="2">
              <b-button :disabled="isReadonly" variant="primary" block @click="save()">Save</b-button>
            </b-col>
          </b-row>
        </b-form>
      </b-card-body>
    </b-card>
    <b-modal ref="offerModalRef" size="lg" @ok="saveOffers" title="Offers">
      <VBrandLimitOfferEdit :selectedOffers="selectedOffers" />
    </b-modal>
  </div>
</template>

<script>
import router from "@/router";
import { mapGetters, mapState } from "vuex";
import VItemList from "@/components/VItemList";
import VBrandLimitOfferList from "@/components/VBrandLimitOfferList";
import VBrandLimitOfferEdit from "@/components/VBrandLimitOfferEdit";

import {
  BRAND_LIMIT_CREATE,
  BRAND_LIMIT_ADD,
  BRAND_LIMIT_SAVE,
  BRAND_LIMIT_GET,
  BRAND_LIMIT_ADD_OFFER,
  BRAND_LIMIT_REMOVE_OFFER
} from "@/store/brand-limit/actions.type";
import {
  SET_BRAND_LIMIT_TEXT,
  SET_BRAND_LIMIT_UPPER_LIMIT,
  SET_BRAND_LIMIT_UNLIMITED_FLAG
} from "@/store/brand-limit/mutations.type";

export default {
  name: "BrandLimitItem",
  components: {
    VItemList,
    VBrandLimitOfferList,
    VBrandLimitOfferEdit
  },
  data() {
    return {
      isReadonly: false,
      selectedOffers: []
    };
  },
  computed: {
    ...mapGetters({
      brandLimit: "currentBrandLimit",
      groups: "groups"
    }),
    ...mapState({
      states: state => state.brandLimit.states
    }),
    brandLimitText: {
      get() {
        return this.$store.getters.currentBrandLimit.brand_limitation_text;
      },
      set(value) {
        this.$store.commit(SET_BRAND_LIMIT_TEXT, value);
      }
    },
    brandCount: {
      get() {
        return this.$store.getters.currentBrandLimit.brand_count_num;
      }
    },
    isUpperLimitDisabled: {
      get() {
        return (this.unlimitedFlag || this.isReadonly);
      }
    },
    upperLimit: {
      get() {
        return this.$store.getters.currentBrandLimit.upper_limit_num;
      },
      set(value) {
        this.$store.commit(SET_BRAND_LIMIT_UPPER_LIMIT, Number(value));
      }
    },
    unlimitedFlag: {
      get() {
        return this.$store.getters.currentBrandLimit.offer_unlimited_flag;
      },
      set(value) {
        this.$store.commit(SET_BRAND_LIMIT_UNLIMITED_FLAG, value);
        if (value) {
          this.upperLimit = 0;
        }
      }
    },
    offerList: {
      get() {
        return this.$store.getters.currentBrandLimit.copay_offers;
      }
    }
  },
  methods: {
    addOffer(offer) {
      if (offer) {
        this.$store.dispatch(BRAND_LIMIT_ADD_OFFER, offer);
      }
    },
    removeOffer(offer) {
      this.$store.dispatch(BRAND_LIMIT_REMOVE_OFFER, offer);
    },
    editOffers() {
      this.selectedOffers = [];
      this.brandLimit.copay_offers.forEach(element => {
        if (element.copay_offer_id) {
          this.selectedOffers.push(element);
        }
      });
      this.$refs.offerModalRef.show();
    },
    saveOffers(evt) {
      // evt.preventDefault();

      for (let i = this.brandLimit.copay_offers.length - 1; i >= 0; i--) {
        let offer = this.brandLimit.copay_offers[i];
        this.$store.dispatch(BRAND_LIMIT_REMOVE_OFFER, offer);
      }
      for (let i = 0; i < this.selectedOffers.length; i++) {
        let offer = this.selectedOffers[i];
        this.$store.dispatch(BRAND_LIMIT_ADD_OFFER, offer);
      }
      
      // this.$refs.offerModalRef.hide();
    },
    async save(evt) {
      if (this.isReadonly) {
        return;
      }

      await this.$validator.validateAll().then(isValid => {
        if (!isValid) {
          return;
        }

        if (this.brandLimit.brand_limit_id) {
          this.brandLimit.copay_offers.forEach(element => {
            // Remove empty offer
            if (!element.copay_offer_id) {
               this.brandLimit.copay_offers.splice(element, 1);
            }
          });
          this.$store.dispatch(BRAND_LIMIT_SAVE, this.brandLimit).then(result => {
            if (result) router.go(-1);
          });
        } else {
          this.$store.dispatch(BRAND_LIMIT_ADD, this.brandLimit).then(result => {
            if (result) router.go(-1);
          });
        }
      });
    },
    clear() {
      router.go(-1);
    }
  },
  created() {
    if (this.$route.params.brand_limit_id) {
      if (this.$route.params.viewActive) {
        this.isReadonly = true;
      } else if (this.$route.params.brand_limit_status_text === "pending_approval") {
        this.isReadonly = true;
      } else {
        this.isReadonly =
          this.$store.getters.groups.indexOf("RTPSDataAdmin") === -1;
      }
      this.$store.dispatch(BRAND_LIMIT_GET, {
        brand_limit_id: this.$route.params.brand_limit_id,
        viewActive: this.$route.params.viewActive
      });
    } else {
      this.$store.dispatch(BRAND_LIMIT_CREATE, { });
    }
  }
};
</script>
<style>
  .brand-limit-item {
    min-height: 500px;
  }
  .offer-header {
    font-weight: 600;
    padding-bottom: 6px;
  }
  .offer-card {
    margin-bottom: 10px;
  }
  .offer-card .card-body {
    padding: 10px;
  }
  .list-group-item input {
    border-width: 0;
  }
  .offer-add {
    padding-left: 0;
  }
  .offer-add i {
    padding-top: 12px;
    padding-bottom: 10px;
  }
  .offer-edit.col-3 i {
    padding-left: 5px;
    padding-right: 5px;
  }
  .offer-status {
    padding: 7px;
    font-size: 14px;
    font-weight: bold;
  }
  .text-danger {
    border-color: red;
  }
  span.text-danger {
    color: red;
  }
  #radio-pending-inactivate {
    margin-left: 25px;
  }
  .section {
    max-height: 500px;
    overflow: auto;
  }
  .selected-field {
    width: 30px;
    text-align: center;
  }
  .default-field {
    width: 150px;
  }
  .status-field {
    width: 150px;
  }
</style>



// WEBPACK FOOTER //
// src/views/BrandLimitItem.vue